
// import './App.css';
// import Home from '../src/pages/home';
// import Dashboard from '../src/pages/home';
// import Reports from '../src/pages/reports/reports';
// import Productreports from '../src/pages/reports/Productreports';
// import Personalreports from '../src/pages/reports/personalreports';
// import Articlereports from '../src/pages/reports/articlereports';
// import Articleqrcode from '../src/pages/qrcodemanagement/ArticleQRCode/articleqrcode';
// import PersonalQRCode from '../src/pages/qrcodemanagement/PersonalQRCode/PersonalQRCode';
// import Productqrcode from '../src/pages/qrcodemanagement/ProductQRCode/productqrcode';
// import Productinformation from './pages/qrcodemanagement/ProductQRCode/productinformation';
// import Addnew from '../src/pages/qrcodemanagement/ProductQRCode/addnew';
// import Reports2 from '../src/pages/reports/reports2';
// import ProductQRCodeList2 from '../src/pages/qrcodemanagement/ProductQRCode/productqrcodelist2';
// import Addnewarticle from '../src/pages/qrcodemanagement/ArticleQRCode/addnewarticle';
// import Articleinfopage from '../src/pages/qrcodemanagement/ArticleQRCode/articleinfopage';
// import Articleqrcodelist from '../src/pages/qrcodemanagement/ArticleQRCode/articleqrcodelist';
// import PersonalQRCodeList from '../src/pages/qrcodemanagement/PersonalQRCode/PersonalQRCodeList';
// import CreateQRCode from '../src/pages/qrcodemanagement/PersonalQRCode/CreateQRCode';
// import Editpersonalqrcode from '../src/pages/qrcodemanagement/PersonalQRCode/Editpersonalqrcode';
// import Categories from '../src/pages/Categories/Categories';
// import CategoriesList from '../src/pages/Categories/CategoriesList';
// import CategoriesList2 from '../src/pages/Categories/CategoriesList2';
// import UserProfile from '../src/pages/UserProfile/UserProfile';
// import Profile from '../src/pages/UserProfile/profile';
// import ProfileCertificatesList from '../src/pages/UserProfile/ProfileCertificatesList';
// import SuppliersList from '../src/pages/UserProfile/SuppliersList';
// import EmployeesList from '../src/pages/UserProfile/EmployeesList';
// import Modal1 from '../src/pages/UserProfile/Modal/Modal1';
// import LabelModal from '../src/pages/UserProfile/Modal/LabelModal';
// import ChangePassword from '../src/pages/UserProfile/Modal/ChangePassword';
// import Login1 from '../src/pages/LoginScreens/Login1';
// import Forgetpassword1 from '../src/pages/LoginScreens/ForgetPassword/Forgetpassword1';
// import Forgetpassword2 from '../src/pages/LoginScreens/ForgetPassword/Forgetpassword2';
// import Forgetpassword3 from '../src/pages/LoginScreens/ForgetPassword/Forgetpassword3';
// import Sttplan from '../src/pages/LoginScreens/Sttsignup/Sttplan';
// import Freesignup from '../src/pages/LoginScreens/Sttsignup/Freesignup';
// import Enterprisesign from '../src/pages/LoginScreens/Sttsignup/Enterprisesign';
// import Inbox from './pages/inbox/inbox';
// import Rolemanagement from '../src/pages/setting/rolemanagement';
// import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

// function App() {
//   return (
//     <Router forceRefresh={true}>
//       <Switch>
//         <Route exact path="/" component={Home} />
//         <Route exact path="/home" component={Dashboard} />
//         <Route exact path="/reports" component={Reports} />
//         <Route exact path="/Productreports" component={Productreports} />
//         <Route exact path="/personalreports" component={Personalreports} />
//         <Route exact path="/articlereports" component={Articlereports} />
//         <Route exact path="/articleqrcode" component={Articleqrcode} />
//         <Route exact path="/PersonalQRCode" component={PersonalQRCode} />
//         <Route exact path="/productqrcode" component={Productqrcode} />
//         <Route exact path="/productinformation" component={Productinformation} />
//         <Route exact path="/addnew" component={Addnew} />
//         <Route exact path="/articleinfopage" component={Articleinfopage} />
//         <Route exact path="/reports2" component={Reports2} />
//         <Route exact path="/productqrcodelist2" component={ProductQRCodeList2} />
//         <Route exact path="/addnewarticle" component={Addnewarticle} />
//         <Route exact path="/articleqrcodelist" component={Articleqrcodelist} />
//         <Route exact path="/PersonalQRCodeList" component={PersonalQRCodeList} />
//         <Route exact path="/createQRCode" component={CreateQRCode} />
//         <Route exact path="/Editpersonalqrcode" component={Editpersonalqrcode} />
//         <Route exact path="/Categories" component={Categories} />
//         <Route exact path="/CategoriesList" component={CategoriesList} />
//         <Route exact path="/CategoriesList2" component={CategoriesList2} />
//         <Route exact path="/UserProfile" component={UserProfile} />
//         <Route exact path="/profile" component={Profile} />
//         <Route exact path="/ProfileCertificatesList" component={ProfileCertificatesList} />
//         <Route exact path="/SuppliersList" component={SuppliersList} />
//         <Route exact path="/EmployeesList" component={EmployeesList} />
//         <Route exact path="/Modal1" component={Modal1} />
//         <Route exact path="/LabelModal" component={LabelModal} />
//         <Route exact path="/ChangePassword" component={ChangePassword} />
//         <Route exact path="/Login1" component={Login1} />
//         <Route exact path="/Forgetpassword1" component={Forgetpassword1} />
//         <Route exact path="/Forgetpassword2" component={Forgetpassword2} />
//         <Route exact path="/Forgetpassword3" component={Forgetpassword3} />
//         <Route exact path="/Sttplan" component={Sttplan} />
//         <Route exact path="/Freesignup" component={Freesignup} />
//         <Route exact path="/Enterprisesign" component={Enterprisesign} />
//         <Route exact path="/inbox" component={Inbox} />
//         <Route exact path="/rolemanagement" component={Rolemanagement} />

//       </Switch>
//     </Router>
//   );
// }

// export default App;




// import React, { useState, useEffect } from 'react';

import React from 'react';
import { withRouter } from "react-router";
import { PageSettings } from './config/page-settings';

import Sidebar from './components/sidebar/sidebar';
import Header from './components/header/header.jsx';
import Content from './components/content/content';
import FloatSubMenu from './components/float-sub-menu/float-sub-menu.jsx';
import { CheckSubuser } from "./api/apiuser"
import swal from "sweetalert";
//import Login1 from '../src/pages/LoginScreens/Login1';
// import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

class App extends React.Component {
	
	constructor(props) {
		super(props);
		
		this.subusercheckActive = this.subusercheckActive.bind(this);
		this.toggleSidebarMinify = (e) => {
			e.preventDefault();
			if (this.state.pageSidebarMinify) {
				this.setState(state => ({
					pageFloatSubMenuActive: false
				}));
			}
			this.setState(state => ({
				pageSidebarMinify: !this.state.pageSidebarMinify
			}));
		}
		this.toggleMobileSidebar = (e) => {
			this.setState(state => ({
				pageSidebarToggled: !this.state.pageSidebarToggled
			}));
		}
		this.toggleMobileSidebarclose = (e) => {
			this.setState(state => ({
				pageSidebarToggled: false
			}));
		}
		this.handleSetPageSidebar = (value) => {
			this.setState(state => ({
				pageSidebar: value
			}));
		}
		this.handleSetPageSidebarMinified = (value) => {
			this.setState(state => ({
				pageSidebarMinify: value
			}));
		}
		this.handleSetPageSidebarWide = (value) => {
			this.setState(state => ({
				pageSidebarWide: value
			}));
		}
		this.handleSetPageSidebarLight = (value) => {
			this.setState(state => ({
				pageSidebarLight: value
			}));
		}
		this.handleSetPageSidebarTransparent = (value) => {
			this.setState(state => ({
				pageSidebarTransparent: value
			}));
		}
		this.handleSetPageSidebarSearch = (value) => {
			this.setState(state => ({
				pageSidebarSearch: value
			}));
		}

		this.toggleRightSidebar = (e) => {
			e.preventDefault();
			this.setState(state => ({
				pageRightSidebarCollapsed: !this.state.pageRightSidebarCollapsed
			}));
		}
		this.toggleMobileRightSidebar = (e) => {
			e.preventDefault();
			this.setState(state => ({
				pageMobileRightSidebarToggled: !this.state.pageMobileRightSidebarToggled
			}));
		}
		this.handleSetPageRightSidebar = (value) => {
			this.setState(state => ({
				pageRightSidebar: value
			}));
		}

		var floatSubMenuRemove;
		var floatSubMenuCalculate;
		var floatSubMenuRemoveTime = 250;
		this.handleFloatSubMenuOnMouseOver = (e) => {
			clearTimeout(floatSubMenuRemove);
			clearTimeout(floatSubMenuCalculate);
		}
		this.handleFloatSubMenuOnMouseOut = (e) => {
			floatSubMenuRemove = setTimeout(() => {
				this.setState(state => ({
					pageFloatSubMenuActive: false
				}));
			}, floatSubMenuRemoveTime);
		}
		this.handleSidebarOnMouseOver = (e, menu) => {
			if (this.state.pageSidebarMinify) {
				if (menu.children) {
					var left = (document.getElementById('sidebar').offsetWidth + document.getElementById('sidebar').offsetLeft) + 'px';

					clearTimeout(floatSubMenuRemove);
					clearTimeout(floatSubMenuCalculate);

					this.setState(state => ({
						pageFloatSubMenu: menu,
						pageFloatSubMenuActive: true,
						pageFloatSubMenuLeft: left
					}));

					var offset = e.currentTarget.offsetParent.getBoundingClientRect();

					floatSubMenuCalculate = setTimeout(() => {
						var targetTop = offset.top;
						var windowHeight = window.innerHeight;
						var targetHeight = document.querySelector('.float-sub-menu-container').offsetHeight;
						var top, bottom, arrowTop, arrowBottom, lineTop, lineBottom;

						if ((windowHeight - targetTop) > targetHeight) {
							top = offset.top + 'px';
							bottom = 'auto';
							arrowTop = '20px';
							arrowBottom = 'auto';
							lineTop = '20px';
							lineBottom = 'auto';
						} else {
							var aBottom = (windowHeight - targetTop) - 21;
							top = 'auto';
							bottom = '0';
							arrowTop = 'auto';
							arrowBottom = aBottom + 'px';
							lineTop = '20px';
							lineBottom = aBottom + 'px';
						}

						this.setState(state => ({
							pageFloatSubMenuTop: top,
							pageFloatSubMenuBottom: bottom,
							pageFloatSubMenuLineTop: lineTop,
							pageFloatSubMenuLineBottom: lineBottom,
							pageFloatSubMenuArrowTop: arrowTop,
							pageFloatSubMenuArrowBottom: arrowBottom,
							pageFloatSubMenuOffset: offset
						}));
					}, 0);

				} else {
					floatSubMenuRemove = setTimeout(() => {
						this.setState(state => ({
							pageFloatSubMenu: '',
							pageFloatSubMenuActive: false
						}));
					}, floatSubMenuRemoveTime);
				}
			}
		}
		this.handleSidebarOnMouseOut = (e) => {
			if (this.state.pageSidebarMinify) {
				floatSubMenuRemove = setTimeout(() => {
					this.setState(state => ({
						pageFloatSubMenuActive: false
					}));
				}, floatSubMenuRemoveTime);
			}
		}
		this.handleFloatSubMenuClick = () => {
			if (this.state.pageSidebarMinify) {
				const windowHeight = window.innerHeight;
				const targetHeight = document.getElementById('float-sub-menu').offsetHeight;
				const targetTop = this.state.pageFloatSubMenuOffset.top;
				const top = ((windowHeight - targetTop) > targetHeight) ? targetTop : 'auto';
				const left = (this.state.pageFloatSubMenuOffset.left + document.getElementById('sidebar').offsetWidth) + 'px';
				const bottom = ((windowHeight - targetTop) > targetHeight) ? 'auto' : '0';
				const arrowTop = ((windowHeight - targetTop) > targetHeight) ? '20px' : 'auto';
				const arrowBottom = ((windowHeight - targetTop) > targetHeight) ? 'auto' : ((windowHeight - targetTop) - 21) + 'px';
				const lineTop = ((windowHeight - targetTop) > targetHeight) ? '20px' : 'auto';
				const lineBottom = ((windowHeight - targetTop) > targetHeight) ? 'auto' : ((windowHeight - targetTop) - 21) + 'px';

				this.setState(state => ({
					pageFloatSubMenuTop: top,
					pageFloatSubMenuLeft: left,
					pageFloatSubMenuBottom: bottom,
					pageFloatSubMenuLineTop: lineTop,
					pageFloatSubMenuLineBottom: lineBottom,
					pageFloatSubMenuArrowTop: arrowTop,
					pageFloatSubMenuArrowBottom: arrowBottom
				}));
			}
		}

		this.handleSetPageContent = (value) => {
			this.setState(state => ({
				pageContent: value
			}));
		}
		this.handleSetPageContentClass = (value) => {
			this.setState(state => ({
				pageContentClass: value
			}));
		}
		this.handleSetPageContentFullHeight = (value) => {
			this.setState(state => ({
				pageContentFullHeight: value
			}));
		}
		this.handleSetPageContentFullWidth = (value) => {
			this.setState(state => ({
				pageContentFullWidth: value
			}));
		}
		this.handleSetPageContentInverseMode = (value) => {
			this.setState(state => ({
				pageContentInverseMode: value
			}));
		}
		this.handleSetpagecontainer = (value) => {
			this.setState(state => ({
				pagecontainer: value
			})

			)
		}
		this.handleSetPageHeader = (value) => {
			this.setState(state => ({
				pageHeader: value
			}));
		}
		this.handleSetPageHeaderMegaMenu = (value) => {
			this.setState(state => ({
				pageHeaderMegaMenu: value
			}));
		}
		this.handleSetPageHeaderLanguageBar = (value) => {
			this.setState(state => ({
				pageHeaderLanguageBar: value
			}));
		}

		this.handleSetPageFooter = (value) => {
			this.setState(state => ({
				pageFooter: value
			}));
		}
		this.handleSetPageTopMenu = (value) => {
			this.setState(state => ({
				pageTopMenu: value
			}));
		}
		this.toggleMobileTopMenu = (e) => {
			e.preventDefault();
			this.setState(state => ({
				pageMobileTopMenu: !this.state.pageMobileTopMenu
			}));
		}
		this.handleSetPageTwoSidebar = (value) => {
			this.setState(state => ({
				pageTwoSidebar: value
			}));
		}
		this.handleSetPageBoxedLayout = (value) => {
			if (value === true) {
				document.body.classList.add('boxed-layout');
			} else {
				document.body.classList.remove('boxed-layout');
			}
		}
		this.handleSetBodyWhiteBg = (value) => {
			if (value === true) {
				document.body.classList.add('bg-white');
			} else {
				document.body.classList.remove('bg-white');
			}
		}

		this.state = {
			pageHeader: true,
			pagecontainer: true,
			pageheaderMegaMenu: false,
			pageHeaderLanguageBar: false,
			hasScroll: false,
			handleSetpagecontainer: this.handleSetpagecontainer,
			handleSetPageHeader: this.handleSetPageHeader,
			handleSetPageHeaderLanguageBar: this.handleSetPageHeaderLanguageBar,
			handleSetPageHeaderMegaMenu: this.handleSetPageHeaderMegaMenu,

			pageSidebar: true,
			pageSidebarWide: false,
			pageSidebarLight: false,
			pageSidebarMinify: false,
			pageSidebarToggled: false,
			pageSidebarTransparent: false,
			pageSidebarSearch: false,
			handleSetPageSidebar: this.handleSetPageSidebar,
			handleSetPageSidebarWide: this.handleSetPageSidebarWide,
			handleSetPageSidebarLight: this.handleSetPageSidebarLight,
			handleSetPageSidebarMinified: this.handleSetPageSidebarMinified,
			handleSetPageSidebarTransparent: this.handleSetPageSidebarTransparent,
			handleSetPageSidebarSearch: this.handleSetPageSidebarSearch,
			handleSidebarOnMouseOut: this.handleSidebarOnMouseOut,
			handleSidebarOnMouseOver: this.handleSidebarOnMouseOver,
			toggleSidebarMinify: this.toggleSidebarMinify,
			toggleMobileSidebar: this.toggleMobileSidebar,
			toggleMobileSidebarclose: this.toggleMobileSidebarclose,

			pageFloatSubMenuActive: false,
			pageFloatSubMenu: '',
			pageFloatSubMenuTop: 'auto',
			pageFloatSubMenuLeft: 'auto',
			pageFloatSubMenuBottom: 'auto',
			pageFloatSubMenuLineTop: 'auto',
			pageFloatSubMenuLineBottom: 'auto',
			pageFloatSubMenuArrowTop: 'auto',
			pageFloatSubMenuArrowBottom: 'auto',
			pageFloatSubMenuOffset: '',
			handleFloatSubMenuOnMouseOver: this.handleFloatSubMenuOnMouseOver,
			handleFloatSubMenuOnMouseOut: this.handleFloatSubMenuOnMouseOut,
			handleFloatSubMenuClick: this.handleFloatSubMenuClick,

			pageContent: true,
			pageContentClass: '',
			pageContentFullHeight: false,
			pageContentFullWidth: false,
			pageContentInverseMode: false,
			handleSetPageContent: this.handleSetPageContent,
			handleSetPageContentClass: this.handleSetPageContentClass,
			handleSetPageContentFullHeight: this.handleSetPageContentFullHeight,
			handleSetPageContentFullWidth: this.handleSetPageContentFullWidth,
			handleSetPageContentInverseMode: this.handleSetPageContentInverseMode,

			pageFooter: false,
			handleSetPageFooter: this.handleSetPageFooter,

			pageTopMenu: false,
			pageMobileTopMenu: false,
			toggleMobileTopMenu: this.toggleMobileTopMenu,
			handleSetPageTopMenu: this.handleSetPageTopMenu,

			pageTwoSidebar: false,
			handleSetPageTwoSidebar: this.handleSetPageTwoSidebar,

			pageRightSidebar: false,
			pageRightSidebarToggled: true,
			pageMobileRightSidebarToggled: false,
			toggleRightSidebar: this.toggleRightSidebar,
			toggleMobileRightSidebar: this.toggleMobileRightSidebar,
			handleSetPageRightSidebar: this.handleSetPageRightSidebar,

			handleSetBodyWhiteBg: this.handleSetBodyWhiteBg,
			handleSetPageBoxedLayout: this.handleSetPageBoxedLayout,

			redirectToHome: false,
		};
	}

	componentDidMount() {
		this.subusercheckActive();
	}

	async subusercheckActive() {
		let checkLogin = localStorage.getItem("loginUserID");
		if (
			checkLogin !== "" &&
			checkLogin !== undefined &&
			checkLogin !== null
		) {
			let Rolename = localStorage.getItem("loginRoleName");
			if (Rolename === "SubUser") {
				let response = await CheckSubuser();
				if (response?.roleDetail?.roleName === "SubUser" && response?.isActive === false) {
					swal({
						title: "Your account has been disabled.",
						text: "Please contact the administrator for assistance.",
						icon: "warning",
					}).then(async (willDelete) => {
						this.props.history.push("/Logout");
					});
				}
			}
		}
	}

	componentWillUnmount() {

		this.subusercheckActive();
		window.removeEventListener('scroll', this.handleScroll)
	}

	handleScroll = () => {
		if (window.scrollY > 0) {
			this.setState(state => ({
				hasScroll: true
			}));
		} else {
			this.setState(state => ({
				hasScroll: false
			}));
		}
		var elm = document.getElementsByClassName('nvtooltip');
		for (var i = 0; i < elm.length; i++) {
			elm[i].classList.add('d-none');
		}
	}

	render() {
		// if (this.state.redirectToHome) {
		// 	return <Link to="/Logout" />;
		//   }
		return (
			<PageSettings.Provider value={this.state}>
				<div className={
					// 'fade page-sidebar-fixed show page-container ' +
					(this.state.pagecontainer ? 'fade page-sidebar-fixed show page-container ' : '') +
					(this.state.pageHeader ? 'page-header-fixed ' : '') +
					(this.state.pageSidebar ? '' : 'page-without-sidebar ') +
					(this.state.pageRightSidebar ? 'page-with-right-sidebar ' : '') +
					(this.state.pageSidebarWide ? 'page-with-wide-sidebar ' : '') +
					(this.state.pageSidebarLight ? 'page-with-light-sidebar ' : '') +
					(this.state.pageSidebarMinify ? 'page-sidebar-minified ' : '') +
					(this.state.pageSidebarToggled ? 'page-sidebar-toggled ' : '') +
					(this.state.pageTopMenu ? 'page-with-top-menu ' : '') +
					(this.state.pageContentFullHeight ? 'page-content-full-height' : '') +
					(this.state.pageTwoSidebar ? 'page-with-two-sidebar ' : '') +
					(this.state.pageRightSidebarCollapsed ? 'page-right-sidebar-collapsed ' : '') +
					(this.state.pageMobileRightSidebarToggled ? 'page-right-sidebar-toggled ' : '') +
					(this.state.hasScroll ? 'has-scroll ' : '')
				}>
					{this.state.pageHeader && (<Header />)}
					{this.state.pageSidebar && (<Sidebar />)}
					{this.state.pageContent && (<Content />)}
					<FloatSubMenu />


				</div>
			</PageSettings.Provider>
		)
	}
}
// export default App;
export default withRouter(App);